<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4 mb-4" v-if="edicao === 'false' || !edicao">Cadastro de grupos de rotas</div>
      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="form.description"
            :error-messages="descriptionErrors"
            :counter="60"
            label="Descrição"
            outlined
            @input="$v.form.description.$touch()"
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'
import { registerVuexModule } from '@/utils/vuexUtils'

import { validateData, validateComputed } from '../_validates'
import grupoDeRotasHttpService from "../_services/grupoDeRotasHttpService";
import grupoDeRotasStore from '../_store'

export default {
  props: {
    edicao: String,
    _id: String,
  },
  components: { FixedButtons, Snackbar },
  mixins: [validationMixin],
  data: () => ({
    showSkeleton: true,
    text: '',
    snackbar: false,
    pararLoader: {
      parar: false,
    },
    form: {
      description: '',
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('cadastroGrupoDeRotasModulePABXStore', ['getSpecificGrupoDeRotas']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'cadastroGrupoDeRotasModulePABXStore', grupoDeRotasStore)

    if (this.edicao === 'true') {
      this.form = this.getSpecificGrupoDeRotas
    }

    this.showSkeleton = false
  },

  methods: {
    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this.edicao === 'true') {
          await grupoDeRotasHttpService.putGrupoDeRotas(this._id, this.form)
        } else {
          await grupoDeRotasHttpService.postGrupoDeRotas(this.form)
        }
        this.$router.push({ name: 'GrupoRotas' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'GrupoRotas' })
    },
  },
}
</script>